var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider} from '@material-ui/core/styles';
import ClientSiteDialog from '../CreateDialogue/ClientSiteDialog';
import EditLabsDialog from '../EditDialogue/EditLabsDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import EditClientSiteDialog from '../EditDialogue/EditClientSiteDialog';
import {logger, customBodyForExcelReport,handleExport,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

//Admin Actions, Client Site Name, Address, City, State, Country, Zipcode

export default function ClientSiteTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [dataSet, setDataSet] = React.useState([]);
     const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        if (refresh) {
            fetch('/api/client_site', {
				 method: 'Get',
			})
                .then(res => res.json())
                .then(json => {
					setDataSet(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
            
    })
    

	
    const handleDialogCallback = (childData) => {
		fetch("/api/client_site", {
		method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "clientSite": [{
                    "Name": childData.Name,
					"Address": childData.Address,
                    "City": childData.City,
                    "State": childData.State,
                    "Country": childData.Country,
                    "Zipcode": childData.Zipcode,
                    "IsActive": childData.IsActive
                }]
            })
        })
        logger(childData);	
        setRefresh(true)
    };

    const handleEditCallback = (childData) => {
		fetch("/api/client_site", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "clientSite": {
                    "ID": childData.ID,
                    "Name": childData.Name,
					"Address": childData.Address,
                    "City": childData.City,
                    "State": childData.State,
                    "Country": childData.Country,
                    "Zipcode": childData.Zipcode,
                    "IsActive": childData.IsActive
                },
            })
        })
        logger(childData);
        setRefresh(true)
    };
	
	 const columns = [


        {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditClientSiteDialog handleEditCallback={handleEditCallback} data={dataSet[dataIndex]} />
                        </div>
                    );
                }

            }
        },
        {
            name: "Name",
            label: "Client Site Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Address",
            label: "Address",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "City",
            label: "City",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "State",
            label: "State",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Country",
            label: "Country",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Zipcode",
            label: "Zipcode",
            options: {
                filter: false,
                sort: true,
            }
        },
		{
            name: "IsActive",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
						    {(dataSet[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
		}	
	];
	
	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 20, 50, 100],
         textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'ClientSiteList.xlsx', columnIndexToRemove:0});
			return false;
		},
        customToolbar: () => {return !isLoading ? <ClientSiteDialog handleDialogCallback={handleDialogCallback} />: null;}
    };


	return (
        
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="clientSitestable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Client Sites
                        </Typography>
                    }
                    data={isLoading ? [] :dataSet}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
        </Box>
        
    );
	
}